export class SelectedIndexScheduleModel{
  groupIndex: number = -1;
  rowIndex: number = -1;
  colIndex: number = -1;
  defaultDateFormat: string = 'long';
}
